import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import './QRDisplay.css';

function QRDisplay() {
  const [qrUrl, setQrUrl] = useState('');
  const [appUrl, setAppUrl] = useState('');

  useEffect(() => {
    // Obtener la URL actual
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port || (protocol === 'https:' ? '443' : '80');
    
    let url;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Si es localhost, intentar obtener IP local
      url = `${protocol}//${hostname}:${port}`;
    } else {
      url = `${protocol}//${hostname}${port ? ':' + port : ''}`;
    }
    
    setAppUrl(url);

    // Generar QR
    QRCode.toDataURL(url, {
      width: 300,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    }, (err, dataUrl) => {
      if (!err) {
        setQrUrl(dataUrl);
      } else {
        console.error('Error generando QR:', err);
      }
    });
  }, []);

  return (
    <div className="qr-display">
      <div className="qr-content">
        <h2>Escanea este QR con tu celular</h2>
        {qrUrl ? (
          <img 
            src={qrUrl} 
            alt="QR Code" 
            className="qr-image"
          />
        ) : (
          <div className="qr-loading">Generando QR...</div>
        )}
        <p className="qr-url">{appUrl}</p>
        <p className="qr-hint">
          Asegúrate de estar en la misma red WiFi
        </p>
      </div>
    </div>
  );
}

export default QRDisplay;
